import { Component, OnInit , EventEmitter, Input, Output, SimpleChanges} from '@angular/core';

import { environment } from '../../../environments/environment';
import { CommonDataService } from '../../services/common-data.service';
import { CommerceDataService } from '../../services/commerce-data.service';


import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule, FormArray  } from '@angular/forms';
import { first } from 'rxjs/operators';

declare var $:any;
declare var iziToast:any;


@Component({
  selector: 'app-shop-products-gridview',
  templateUrl: './shop-products-gridview.component.html',
  styleUrls: ['./shop-products-gridview.component.css']
})
export class ShopProductsGridviewComponent implements OnInit {

  @Input() displayProducts;
  @Output() productClicked = new EventEmitter<any>();
  loading = true
  products = []

  userWishlist = []

  p: number = 1;
  itemsPerPage = 15;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private _data: CommonDataService,
    private _ecom: CommerceDataService
  ) { }

  ngOnInit() {
    this.products = []
    this.products = this.displayProducts
    $('#initialise-page').trigger('click');
    console.log(this.products)
    this.loading = false
  }

  clickProduct(details) {
    this.productClicked.emit(details);
  }

  getProductImageSrc(modelData){

    if( modelData['files'] && modelData['files']['uploads'] && Array.isArray(modelData['files']['uploads']) && modelData['files']['uploads'].length > 0) {
      let productImages = modelData['files']['uploads']

      for (let index = 0; index < productImages.length; index++) {
        let element = productImages[index];

        if(element['tmp_name'] && element['tmp_name'] != '') {
          let srcStrings = element['tmp_name'].split("public/");
          let src = environment.filesSrc+'/'+srcStrings[1]
          element['src'] = src
          return src
        }
        
      }

    }

      return ''
  }

  addToCart(product) {


    if(this._ecom.checkInstantAddToCart(product)) {
      product['variationId'] = 0
      this._ecom.addToShoppingCart(product, 1)

      iziToast.success({
          title: 'Success',
          position: 'topRight',
          icon: 'icon-circle-check',
          message: 'Product added to shopping cart.'
      });
    }

    else {
      this.router.navigate(['/shop/products/{{product["id"]']);
    }
  }

   ngOnChanges(changes: SimpleChanges) {
    // only run when property "data" changed
    this.loading =true

    $('#loader').show();

    if (changes['displayProducts']) {
      this.products = changes['displayProducts'].currentValue;
      $('#initialise-page').trigger('click');
      console.log(this.products)
      setTimeout(()=>{    //<<<---    using ()=> syntax
            this.loading =false
            $('#loader').hide();
      }, 2000);
    }
   
  }

  productInWishList(id) {
    for (let index = 0; index < this.userWishlist.length; index++) {
      let element = this.userWishlist[index];

      if(id == element['id']) {
        return true
      }
    }

    return false
  }

}
